import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const BillingApi = createApi({
  reducerPath: "BillingApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["BILLINGAPI"],
  endpoints: (build) => ({
    getBillingRecords: build.query({
      query: ({
        page = 1,
        limit = 10,
        userId = "",
        type = "",
        status = "",
      }) => ({
        url: `/billing?page=${page}&limit=${limit}&userId=${userId}&type=${type}&status=${status}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["BILLINGAPI"],
    }),

    getBillingById: build.query({
      query: ({ id }) => ({
        url: `/billing/${id}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["BILLINGAPI"],
    }),

    createBillingRecord: build.mutation({
      query: ({ data }) => ({
        url: `/billing`,
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["BILLINGAPI"],
    }),

    updateBillingRecord: build.mutation({
      query: ({ id, data }) => ({
        url: `/billing/${id}`,
        method: "PUT",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["BILLINGAPI"],
    }),

    deleteBillingRecord: build.mutation({
      query: ({ id }) => ({
        url: `/billing/${id}`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["BILLINGAPI"],
    }),
  }),
});

export const {
  useGetBillingRecordsQuery,
  useGetBillingByIdQuery,
  useCreateBillingRecordMutation,
  useUpdateBillingRecordMutation,
  useDeleteBillingRecordMutation,
  useLazyGetBillingRecordsQuery,
  useLazyGetBillingByIdQuery,
} = BillingApi;
